"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpPollingSource = void 0;
const core_types_1 = require("@dqm/core-types");
const value_observer_1 = require("@dqm/value-observer");
const axios_1 = __importDefault(require("axios"));
const ValueNotAvailableError_1 = require("./ValueNotAvailableError");
class HttpPollingSource {
    constructor(fetchUrl, { method = "get", fetchTimeout = 30000, pollInterval, requestBody, } = {}) {
        this.headers = {};
        this.fetchUrl = fetchUrl;
        this.method = method;
        this.fetchTimeout = fetchTimeout;
        this.pollInterval = pollInterval;
        this.setRequestBody(requestBody);
        this.running = false;
        this.pollTimer = null;
        this.listeners = [];
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.running) {
                throw new core_types_1.InvalidOperationError("HttpPollingSource: already started");
            }
            if (this.pollInterval === undefined) {
                throw new core_types_1.ArgumentError("HttpPollingSource: invalid poll interval");
            }
            this.running = true;
            yield this.executePollCycle();
        });
    }
    stop() {
        if (!this.running) {
            throw new core_types_1.InvalidOperationError("HttpPollingSource: already stopped");
        }
        this.running = false;
        this.stopPollTimer();
    }
    setRequestBody(body) {
        this.requestBody = body;
    }
    setHeader(key, value) {
        this.headers[key] = value;
    }
    executePollCycle() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.poll();
            if (this.running) {
                this.startPollTimer();
            }
        });
    }
    startPollTimer() {
        this.stopPollTimer();
        this.pollTimer = setTimeout(() => {
            this.executePollCycle();
        }, this.pollInterval);
    }
    stopPollTimer() {
        if (this.pollTimer !== null) {
            clearTimeout(this.pollTimer);
            this.pollTimer = null;
        }
    }
    isRunning() {
        return this.running;
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const value = yield this.fetch();
                this.invokeRegisteredListeners(value_observer_1.ValueStatus.Ok, null, value);
            }
            catch (error) {
                if (error instanceof ValueNotAvailableError_1.ValueNotAvailableError) {
                    this.invokeRegisteredListeners(value_observer_1.ValueStatus.Unavailable, null, null);
                }
                else if (error instanceof Error) {
                    this.invokeRegisteredListeners(value_observer_1.ValueStatus.Fault, error, null);
                }
                else {
                    this.invokeRegisteredListeners(value_observer_1.ValueStatus.Fault, new core_types_1.UnknownError("thrown value was " + error), null);
                }
            }
        });
    }
    formatResponse(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return data;
        });
    }
    fetch() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, status } = yield (0, axios_1.default)({
                method: this.method,
                url: this.fetchUrl,
                timeout: this.fetchTimeout,
                data: this.requestBody,
                headers: this.headers,
            });
            if (status === 204)
                throw new ValueNotAvailableError_1.ValueNotAvailableError();
            return this.formatResponse(data);
        });
    }
    invokeRegisteredListeners(status, error, data) {
        for (const listener of this.listeners) {
            try {
                listener(status, error, data);
            }
            catch (_a) {
            }
        }
    }
    registerValueEventListener(listener) {
        this.listeners.push(listener);
        return () => {
            const index = this.listeners.indexOf(listener);
            if (index === -1) {
                throw new core_types_1.InvalidOperationError("removing listener: no listener found");
            }
            this.listeners.splice(index, 1);
        };
    }
}
exports.HttpPollingSource = HttpPollingSource;
//# sourceMappingURL=HttpPollingSource.js.map